import { formatColor } from '@meitu/saas-colors';
import { checkLinearGradient } from '@/utils/color-kit';
import { ILayerProps, ILinearGradient, IQrCodeLayerProps } from '@/version-types';

export function setContent(layer: ILayerProps, content: { official: string; text: string }) {
    const data = layer.data as IQrCodeLayerProps;

    data.text = content.text || '';
    data.official = content.official || '';
}

export function setStyle(
    layer: ILayerProps,
    style: { fill?: string; stroke?: string; strokeGradient?: ILinearGradient | null },
) {
    const { fill, stroke, strokeGradient } = style;
    const data = layer.data as IQrCodeLayerProps;
    const isGradient = !!strokeGradient || (stroke && checkLinearGradient(stroke));

    if (fill !== undefined) {
        data.fill = fill || '';
    }

    if (stroke !== undefined || strokeGradient !== undefined) {
        // ATTENTION: 渲染层是优先使用渐变，这里写入的逻辑也是优先判断渐变
        // 同时因为写入有两种格式，这里也统一进行兼容
        if (isGradient) {
            data.strokeGradient = strokeGradient || (formatColor(stroke!) as ILinearGradient);
            data.stroke = '';
        } else {
            data.strokeGradient = null;
            data.stroke = stroke || '';
        }
    }
}
